export enum AuthorizationOperations {
  VIEW = 'View',
  OPERATE = 'Operate',
  CONFIGURATION = 'Configuration',
  ACCESS_RIGHTS_MANAGEMENT = 'AccessRightsManagement',
  TICKET_CREATE = 'Ticket.create'
}
